import {
  SET_TERMINAL_AUTH_DATA,
  SET_TERMINAL_BALANCE,
  SET_STARTUP_SETTINGS,
  LOGIN_ADMIN,
  SET_PROFILE_ERROR,
  SET_LANGUAGE,
  SET_BALANCE,
  CASHOUT_MONEY,
  SET_CURRENCY,
  TITO_CASHOUT_BET,
  SHOW_LAST_BETS_LIST,
  TERMINAL_ERROR,
  SET_POPUP_LAUNCHER,
  TITO_ACCEPT_CASHOUT,
  LOCK_TERMINAL,
  UNLOCK_TERMINAL,
  HIDE_TERMINAL_ERROR,
  SEND_LOGS,
  SHOW_KEYBOARD,
  SET_TAX,
  USER_DID_LOGIN,
  USER_DID_LOGOUT,
  MOUSE_MOVE_POSITION,
  SET_TERMINAL_ACUMULATOR_BONUSE,
  IS_ADMIN_LOGGED_IN,
  REGISTER_MODE,
  IS_CARD_REGISTERED,
  CONFIRM_REGISTRATION_NEW_CARD,
  ADD_TO_BALANCE,
  CLEAR_CARD_REGISTERED,
  PRINT_LOTTERY_TICKET,
  LOYAL_CARD,
  PRINT_BOOKING_TICKET,
  GET_SUPERBET_TICKET_BY_ID,
  SET_SUPERBET_ID,
  REJECT_SUPERBET,
  CASINO_GAMES_OPENED,
  ADMIN_USER_COMMANDS,
  SET_LOYAL_CARD_INPUT_ACTIVE,
  DEPOSIT_TO_CLIENT_ACCOUNT,
  PRINT_BET_BUILDER_TICKET,
  PRINT_ONE_TIME_PASSWORD,
  CHECK_ONE_TIME_LOGIN,
  SET_VERIFICATION_INFO,
  END_VERIFICATION_SESSION,
  RESET_VERIFICATION_SESSION,
  SET_TERMINAL_SUPERBET_DATA,
  SET_MERCHANT_ID,
  GET_MERCHANT_INFO,
  SET_FREE_BONUSES,
  INCREASE_LOCAL_BALANCE,
  SET_LAST_MONEY_INPUT_TYPE,
  SET_MONEY_INPUT_ACTIVE,
  SET_TERMINAL_DEPOSIT_MODE,
  SET_PLAYER_PAYMENT_INFO,
  GET_BET_PLAYER_PAYEMNT_INFO_BULK,
  RESET_PLAYER_PAYMENT_INFO,
  SAVE_PLAYER_PAYMENT_INFO,
  GET_SAVED_PLAYER_PAYMENT_INFO,
  RECEIVE_SAVED_PLAYER_PAYMENT_INFO,
  SET_PROFIT_BOOST_INFO,
  SET_TERMINAL_USAGE_CONFIRMED,
  PARTIAL_CASHOUT_MONEY
} from "./actionTypes/index";

export const EndVerificationSession = () => ({ type: END_VERIFICATION_SESSION });
export const ResetVerificationSession = () => ({ type: RESET_VERIFICATION_SESSION });

export const SetTerminalSuperbetData = (payload) => ({
  type: SET_TERMINAL_SUPERBET_DATA,
  payload,
});

export const SetTerminalAuthData = (payload) => ({
  type: SET_TERMINAL_AUTH_DATA,
  payload,
});

export const SetTerminalUsageConfirmed = (payload) => ({
  type: SET_TERMINAL_USAGE_CONFIRMED,
  payload,
});

export const SetVerificationInfo = (payload) => ({
  type: SET_VERIFICATION_INFO,
  payload,
});

export const depositToClientAccount = (clientId) => ({
  type: DEPOSIT_TO_CLIENT_ACCOUNT,
  clientId,
});

export const SetBonuses = (payload) => ({
  type: SET_TERMINAL_ACUMULATOR_BONUSE,
  payload,
});

export const SetFreeBonuses = (payload) => ({
  type: SET_FREE_BONUSES,
  payload,
});

export const SetStartupSettings = (payload) => ({
  type: SET_STARTUP_SETTINGS,
  payload,
});
export const casinoGamesPageOpened = () => ({
  type: CASINO_GAMES_OPENED,
});

export const SetTerminalBalance = (payload) => ({
  type: SET_TERMINAL_BALANCE,
  payload,
});

export const HandleMousePosition = (payload) => ({
  type: MOUSE_MOVE_POSITION,
  payload,
});

export const UserDidLogin = (payload) => ({
  type: USER_DID_LOGIN,
  payload,
});

export const UserDidLogOut = (payload) => ({
  type: USER_DID_LOGOUT,
  payload,
});

export const LoginAdmin = (payload) => ({
  type: LOGIN_ADMIN,
  payload,
});

export const SetTax = (payload) => ({
  type: SET_TAX,
  payload,
});

export const UnlockTerminal = (payload) => ({
  type: UNLOCK_TERMINAL,
  payload,
});

export const TitoAcceptCashout = (payload) => ({
  type: TITO_ACCEPT_CASHOUT,
  payload,
});
export const RegisterMode = (payload) => ({
  type: REGISTER_MODE,
  payload,
});

export const LockTerminal = (payload) => ({
  type: LOCK_TERMINAL,
  payload,
});

export const SetTerminalPopupLauncher = (payload) => ({
  type: SET_POPUP_LAUNCHER,
  payload,
});

export const TerminalError = (payload) => ({
  type: TERMINAL_ERROR,
  payload,
});

export const HideTerminalError = (payload) => ({
  type: HIDE_TERMINAL_ERROR,
  payload,
});

export const TitoCashoutAcceptBet = (payload) => ({
  type: TITO_CASHOUT_BET,
  payload,
});

export const SetProfileError = (payload) => ({
  type: SET_PROFILE_ERROR,
  payload,
});

export const SetLanguage = (payload) => ({
  type: SET_LANGUAGE,
  payload,
});

export const SetBalance = (payload) => ({
  type: SET_BALANCE,
  payload,
});

export const IsAdminLoggedIn = (payload) => ({
  type: IS_ADMIN_LOGGED_IN,
  payload,
});

export const IsCardRegistered = (payload) => ({
  type: IS_CARD_REGISTERED,
  payload,
});
export const ClearCardRegistered = (payload) => ({
  type: CLEAR_CARD_REGISTERED,
  payload,
});
export const ConfirmRegistrationNewCard = (payload) => ({
  type: CONFIRM_REGISTRATION_NEW_CARD,
  payload,
});

export const CashoutMoney = (payload) => ({
  type: CASHOUT_MONEY,
  payload,
});

export const PartialCashoutMoney = (payload) => ({
  type: PARTIAL_CASHOUT_MONEY,
  payload,
});

export const PrintBookingTicket = (payload) => ({
  type: PRINT_BOOKING_TICKET,
  payload,
});

export const SetCurrency = (payload) => ({
  type: SET_CURRENCY,
  payload,
});

export const PrintBetBuilderTicket = (payload) => ({
  type: PRINT_BET_BUILDER_TICKET,
  payload,
});

export const PrintLotteryTickets = (payload, isCopy) => ({
  type: PRINT_LOTTERY_TICKET,
  payload,
  isCopy,
});

export const LoyalCard = (payload) => ({
  type: LOYAL_CARD,
  payload,
});

export const SetLoyalCardInputActive = (isActive) => ({
  type: SET_LOYAL_CARD_INPUT_ACTIVE,
  isActive,
});

export const GetSuperbetTicketById = (payload) => ({
  type: GET_SUPERBET_TICKET_BY_ID,
  payload,
});
export const SetSuperbetId = (payload) => ({
  type: SET_SUPERBET_ID,
  payload,
});
export const RejectSuperbet = (payload) => ({
  type: REJECT_SUPERBET,
  payload,
});

export const ShowLastBetsList = (payload) => ({
  type: SHOW_LAST_BETS_LIST,
  payload,
});
export const addToBalance = (payload) => ({
  type: ADD_TO_BALANCE,
  payload,
});

export const ShowKeyboard = (payload) => ({
  type: SHOW_KEYBOARD,
  payload,
});

export const SendLogs = (payload) => ({
  type: SEND_LOGS,
  payload,
});

export const AdminUserCommands = (command, payload) => ({
  type: ADMIN_USER_COMMANDS,
  command,
  payload,
});

export const printOneTimePassword = (password) => ({
  type: PRINT_ONE_TIME_PASSWORD,
  payload: password,
});

export const CheckOneTimeLogin = (barcode) => ({
  type: CHECK_ONE_TIME_LOGIN,
  payload: barcode,
});

export const setMerchantId = (merchantId) => ({
  type: SET_MERCHANT_ID,
  payload: merchantId,
});

export const receiveSavedPlayerPaymentInfo = (playerInfo) => ({
  type: RECEIVE_SAVED_PLAYER_PAYMENT_INFO,
  payload: playerInfo
})

export const getMerchantInfo = () => ({
  type: GET_MERCHANT_INFO,
});

export const setProfitBoostInfo = (percent, stake) => ({
  type: SET_PROFIT_BOOST_INFO,
  payload: {
    percent,
    stake
  }
});

export const increaseLocalBalance = (amount) => ({
  type: INCREASE_LOCAL_BALANCE,
  payload: {
    data: amount,
  },
});

export const setPlayerPaymentInfo = (info) => ({
  type: SET_PLAYER_PAYMENT_INFO,
  payload: info,
});

export const resetPlayerPaymentInfo = (info) => ({
  type: RESET_PLAYER_PAYMENT_INFO,
  payload: info,
});

export const getBetPlayerPaymentInfoBulk = (ticketsList) => ({
  type: GET_BET_PLAYER_PAYEMNT_INFO_BULK,
  payload: ticketsList,
});

export const setLastMoneyInputType = (type) => ({
  type: SET_LAST_MONEY_INPUT_TYPE,
  payload: {
    data: type,
  },
});

export const setMoneyInputActive = (state) => ({
  type: SET_MONEY_INPUT_ACTIVE,
  payload: {
    data: state,
  },
});
export const setTerminalDepositMode = (mode) => ({
  type: SET_TERMINAL_DEPOSIT_MODE,
  mode,
});

export const savePlayerPaymentInfo = (playerInfo) => ({
  type: SAVE_PLAYER_PAYMENT_INFO,
  payload: playerInfo
})

export const getSavedPlayerPaymentInfo = () => ({
  type: GET_SAVED_PLAYER_PAYMENT_INFO
})
